import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getAllRoles = async () => {
  try {
    const resp = await apiClient.get(`/invoiceRoleManagement`, {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
